import { InventoryTypePlaceholderPage } from "../inventory-placeholder";

export const HealthyDonorsPage = () => {
  return <InventoryTypePlaceholderPage title="Healthy Donors" />;
};
